<h2 mat-dialog-title>{{container.inventoryString()}}</h2>
<mat-dialog-content class="mat-typography">
  <mat-form-field>
    <mat-label>Search equipment list</mat-label>
    <input matInput [(ngModel)]="templateFilter" (ngModelChange)="filterTemplates()"
      [matAutocomplete]="templateAuto">
    <mat-autocomplete #templateAuto="matAutocomplete" (optionSelected)="onTemplateSelect($event)">
      @for (e of filteredEquipment; track e) {
        <mat-option [value]="e.name">
          {{e.name}} ({{formatGp(e.price)}}, {{e.weight}}cn)
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
  <br/>
  <mat-form-field>
    <mat-label>Name</mat-label>
    <input matInput [(ngModel)]="container.name"/>
  </mat-form-field>
  <br/>
  <mat-form-field>
    <mat-label>Weight</mat-label>
    <input matInput [(ngModel)]="container.weight" type="number"/>
  </mat-form-field>
  <br/>
  <mat-form-field>
    <mat-label>Maximum Capacity</mat-label>
    <input matInput [(ngModel)]="container.capacity" type="number"/>
  </mat-form-field>
  <br/>
  <mat-form-field>
    <mat-label>Slots</mat-label>
    <input matInput [(ngModel)]="container.slots" type="number"/>
  </mat-form-field>
  <br/>

  <mat-dialog-actions>
    @if (!this.slung_items) {
      <button mat-button color="warn" (click)="deleteContainer()">Delete</button>
    }
    <span class="spacer"></span>
    @if (this.slung_items) {
      <button mat-button [mat-dialog-close]="">Cancel</button>
    }
    <button mat-button (click)="upsertContainer()" [mat-dialog-close]="" cdkFocusInitial>Done</button>
  </mat-dialog-actions>

</mat-dialog-content>
